import {RoutesModel} from "./models/Routes.model";
import {Home} from "../../features/home/Home";

import {nameRoutes} from "./nameRoutes";
import {Companies} from "../../features/management/companies/Companies";
import {Calendar} from "../../features/calendar/Calendar";
import {Employees} from "../../features/management/employees/Employees";
import {typeUser} from "../data/typeUser";
import {Pharmacists} from "../../features/management/pharmacists/Pharmacists";
import React from "react";
import {CloseDays} from "../../features/management/closeDays/CloseDays";
import {EmployeesSituation} from "../../features/hours/employeesSituation/EmployeesSituation";
import {HoursMany} from "../../features/hours/hoursMany/HoursMany";
import {Stats} from "../../features/hours/stats/Stats";
import {Prospect} from "../../features/hours/propsect/Prospect";
import {CalendarEmployee} from "../../features/calendar/CalendarEmployee";


const authList: RoutesModel = {
    list: [
        {
            path: '/home',
            name: nameRoutes.home,
            component: <Home/>,
            title: 'Home'
        },
        {
            path: '/pharmacists',
            name: nameRoutes.pharmacists,
            component: <Pharmacists/>,
            title: 'Lista Farmacisti',
            roles: [typeUser.admin]
        },
        {
            path: '/companies',
            name: nameRoutes.companies,
            component: <Companies/>,
            title: 'Aziende',
            roles: [typeUser.admin, typeUser.pharmacist],
            permissions: ['selectedPharmacist', 'limitEmployeeRespected']
        },
        // {
        //     path: '/typeHours',
        //     name: nameRoutes.typologyHours,
        //     component: <TypeHours/>,
        //     title: 'Tipologia ore',
        //     roles: [typeUser.admin, typeUser.pharmacist],
        //     permissions: ['selectedPharmacist', 'limitEmployeeRespected']
        // },
        {
            path: '/closeDays',
            name: nameRoutes.closeDays,
            component: <CloseDays/>,
            title: 'Giorni chiusura',
            roles: [typeUser.admin, typeUser.pharmacist],
            permissions: ['selectedPharmacist', 'limitEmployeeRespected']
        },
        {
            path: '/employees',
            name: nameRoutes.employees,
            component: <Employees/>,
            title: 'Dipendenti',
            roles: [typeUser.admin, typeUser.pharmacist],
            permissions: ['selectedPharmacist']
        },
        {
            path: '/calendar',
            name: nameRoutes.calendar,
            component: <Calendar/>,
            title: 'Calendario',
            roles: [typeUser.admin, typeUser.pharmacist],
            permissions: ['selectedPharmacist', 'limitEmployeeRespected']
        },
        {
            path: '/calendar',
            name: nameRoutes.calendar,
            component: <CalendarEmployee/>,
            title: 'Calendario',
            roles: [typeUser.employee],
            permissions: ['selectedPharmacy']
        },
        {
            path: '/employeesSituation',
            name: nameRoutes.employeesSituation,
            component: <EmployeesSituation/>,
            title: 'Situazione dipendenti',
            roles: [typeUser.admin, typeUser.pharmacist],
            permissions: ['selectedPharmacist', 'selectedPharmacy', 'limitEmployeeRespected']
        },
        {
            path: '/hoursMany',
            name: nameRoutes.hoursMany,
            component: <HoursMany/>,
            title: 'Monte ore',
            roles: [typeUser.admin, typeUser.pharmacist],
            permissions: ['selectedPharmacist', 'selectedPharmacy', 'limitEmployeeRespected']
        },
        {
            path: '/stats',
            name: nameRoutes.stats,
            component: <Stats/>,
            title: 'Statistiche',
            roles: [typeUser.admin, typeUser.pharmacist],
            permissions: ['selectedPharmacist', 'selectedPharmacy', 'limitEmployeeRespected']
        },
        {
            path: '/prospect',
            name: nameRoutes.prospect,
            component: <Prospect/>,
            title: 'Prospetto',
            roles: [typeUser.admin, typeUser.pharmacist],
            permissions: ['selectedPharmacist', 'selectedPharmacy', 'limitEmployeeRespected']
        },
    ],
    redirect: '/home'
}

export default authList;
